export interface FormFieldDefinition {
  title: string;
  fieldType: string;
  fieldRequired?: boolean;
  description?: string;
  markdownDescription?: string;
  values?: string[];
  size?: string;
  minDate?: string;
  maxDate?: string;
  zipCodes?: string;
  zipCodeErrorMessage?: string;
}

interface FieldTypeOption {
  value: string;
  label: string;
  /** Nur mit Spielgruppe Plus wählbar. */
  plusOnly?: boolean;
}

export const FIELD_TYPES: FieldTypeOption[] = [
  { value: "string", label: "Text" },
  { value: "select", label: "Auswahl" },
  { value: "date", label: "Datum" },
  { value: "offer", label: "Angebot" },
  { value: "zipCode", label: "PLZ" },
  { value: "boolean", label: "Checkbox", plusOnly: true },
  { value: "number", label: "Zahl", plusOnly: true },
  { value: "integer", label: "Ganzzahl", plusOnly: true },
  { value: "title", label: "Abschnitt", plusOnly: true },
  { value: "markdown", label: "Formatierter Text", plusOnly: true }
];

const EXTRA_LABELS: Record<string, string> = { divider: "Trenner", email: "E-Mail" };

export const fieldTypeLabel = (fieldType: string): string =>
  FIELD_TYPES.find((type) => type.value === fieldType)?.label ?? EXTRA_LABELS[fieldType] ?? fieldType;

/** Abschnittstitel gliedern die Feldliste — sie sind selbst Felder vom Typ "title". */
export const isSectionField = (field: FormFieldDefinition): boolean => field.fieldType === "title";

export const TITLE_SIZES = ["h1", "h2", "h3", "h4", "h5", "h6"];
